import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AuthHandleComponent } from './auth-handle/auth-handle.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { RootComponent } from './root/root.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from './alert/alert.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SelectTenantComponent } from './select-tenant/select-tenant.component';
import { AccountCreatedComponent } from './account-created/account-created.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { DatePipe } from '@angular/common';

const routes: Routes = [
  { path: '', component: AppComponent },
  { path: 'auth_handle', component: AuthHandleComponent },
  { path: 'error', component: AccessDeniedComponent },
  { path: 'account_created', component: AccountCreatedComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    declarations: [
        AppComponent,
        AuthHandleComponent,
        VerifyEmailComponent,
        ResetPasswordComponent,
        PageNotFoundComponent,
        ProgressBarComponent,
        RootComponent,
        AlertComponent,
        SignInComponent,
        SelectTenantComponent,
        AccountCreatedComponent,
        SignOutComponent,
        AccessDeniedComponent
    ],
    imports: [
        BrowserModule,
        RouterModule.forRoot(routes, {
            enableTracing: false,
            canceledNavigationResolution: 'replace',
            paramsInheritanceStrategy: 'emptyOnly',
            urlUpdateStrategy: 'deferred',
        }),
        FormsModule,
        ReactiveFormsModule
    ],
    bootstrap: [RootComponent],
    providers: [
        DatePipe
    ]
})
export class AppModule { }
